import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { usePurchaseRoDetailsModel } from "../scmPurchaseRoModel";
import { Description } from "@/components/YhBox/Description";
import { useScmSaleRoDetailModel } from "@/views/scmBill/scmSaleRo/scmSaleRoModel"
import { Button } from 'antd';


export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const { getTreeNodeName } = useScmSaleRoDetailModel();
    const { lookFormVal: { returnCode, status, supplierName } } = usePurchaseRoDetailsModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatu: IDescription[] = [
        {
            label: "采购退货单",
            value: returnCode ?? "",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "供应商",
            value: supplierName,
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}